import { useState, useEffect } from 'react';
import {Card, Col, Row, Modal} from "antd";
import { useSearchParams,useLocation, useNavigate } from "react-router-dom";
import { SearchContainer, SearchIcon, SearchInput, SearchButton, ButtonContainer, StyledCarousel } from './style';
import { SearchOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import {MySegmented, MyText} from "../../components";
import {useTranslation} from "react-i18next";
import { useEmbeddedNavigate } from '../../utils/context/embed';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMainVideoListAction } from '../../utils';

const isMobile = window.innerWidth < 768;

export const MainVideoPage = () => {
  const {t} = useTranslation("common");
  // const [playlists, setPlaylists] = useState<any[]>([]);
  // const [multimedia, setMultimedia] = useState<any[]>([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState<string | null>(null);
  const [searchTerm, setSearchTerm] = useState('');
  // const [content, setContent] = useState<any>(null);
  const [hoveredPlaylist, setHoveredPlaylist] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();
  const dispatch = useDispatch();
  const mainVideoList = useSelector((state: any) => state.materials?.mainVideoList ?? { data: null, loading: false });
  const content = mainVideoList.data?.ideas || [];
  const playlists = mainVideoList.data?.playlists || [];
  const multimedia = mainVideoList.data?.multimedia || [];
  const loading = mainVideoList.loading;
  const handleVideoClick = (link: string) => {
    setSelectedVideo(link);
    setModalVisible(true);
  };

  const handleModalClose = () => {
    setModalVisible(false);
    setSelectedVideo(null);
  };

  // useEffect(() => {
  //   const fetchContent = async () => {
  //       try {
  //         const fetchedContent = await fetchMainVideoList(); 
  //         setContent(fetchedContent.ideas);
  //         setPlaylists(fetchedContent.playlists || []);
  //         setMultimedia(fetchedContent.multimedia || []);
  //       } catch (error) {
  //         console.error('Error fetching content:', error);
  //       }
  //   };

  //   fetchContent();
  // }, []);

  useEffect(() => {
    dispatch(fetchMainVideoListAction());
  }, []);

  const handleClick = () => {
    embeddedNavigate('/');
  };

  return (
    <>
    <Helmet>
      <title>
        Обучающие мультфильмы для детей
      </title>
      <meta
        name="description"
        content="Смотрите мультфильмы для развития речи, внимания и памяти. Обучение детей в игровой и интересной форме."
      />
      <meta
        name="keywords"
        content="мультфильмы для детей, развивающие мультфильмы онлайн, мультфильмы для малышей, мультфильмы для дошкольников, развивающие видео для детей"
      />
    </Helmet>
    <Row justify='center'>
      <Col span={20}>
        <Row gutter={[24, 24]}>
        <Col span={24}>
            <div style={{ display: 'flex',gap: isMobile ? '14px' : '24px', alignItems: 'center' }}>
              <ButtonContainer onClick={handleClick}>
                <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
              </ButtonContainer>
              <MyText color='#0A033C' size={isMobile ? 22 : 32} weight={800} style={{ fontFamily: 'Nunito', display: 'block' }}>
                {`${t("multimediaLibrary")}`}
              </MyText>
            </div>
          </Col>

          <Col span={24}>
          <Card>
          <SearchContainer>
            {!isMobile && (
              <SearchIcon>
                <SearchOutlined />
              </SearchIcon>
            )}
            <SearchInput
              type="text"
              placeholder={isMobile ? `${t("search")}...` : `${t("searchByKeyword")}...`}
              value={searchTerm}
            />
            <SearchButton isMobile={isMobile}>
              {isMobile ? <SearchOutlined style={{ fontSize: '30px' }} /> : `${t("search")}`}
            </SearchButton>
          </SearchContainer>
      
          {playlists.length > 0 && playlists.map((playlist) => (
            <div key={playlist.id} style={{ margin: '32px 0' }}>
              <Row justify="space-between" align="middle" style={{ marginBottom: '24px' }}>
                <MyText color='#0A033C' size={32} weight={800} style={{ fontFamily: 'Nunito', display: 'block' }}>
                  {playlist.name}
                </MyText>
              </Row>
      
              <Row >
                <Col span={24}>
                <div
              onMouseEnter={() => setHoveredPlaylist(playlist.id)}
              onMouseLeave={() => setHoveredPlaylist(null)}
            >
              {!isMobile ? (
                <StyledCarousel
                dots={false}
                slidesToScroll={2}
                slidesToShow={3}
                arrows={
                  hoveredPlaylist === playlist.id &&
                  multimedia.filter(item => item.playlist_id === playlist.id).length > 3
                }
              >
                {multimedia
                      .filter(item => item.playlist_id === playlist.id)
                      .map((item) => {
                        const videoId = new URL(item.link).searchParams.get('v');
                        const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
      
                        return (
                          <div key={item.id} style={{ padding:'0 8px' }}>
                            <div onClick={() => handleVideoClick(item.link)} onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(0.97)'}
                              onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'} style={{ cursor: 'pointer', transition: 'transform 0.3s ease', width: '95%' }}>
                              <div style={{
                                borderRadius: '12px',
                                background: '#fff',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                              }}>
                                <div style={{
                                  width: '100%',
                                  paddingTop: '55.25%',
                                  position: 'relative',
                                  borderRadius: '12px',
                                  overflow: 'hidden',
                                }}>
                                  <img
                                    src={thumbnailUrl}
                                    alt={item.name}
                                    style={{
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      width: '100%',
                                      height: '100%',
                                      objectFit: 'cover'
                                    }}
                                  />
                                </div>
                                <div style={{
                                  display: 'flex',
                                  width: '100%',
                                  marginTop: '24px',
                                  justifyContent: 'flex-start',
                                }}>
                                  <MyText color='rgba(19, 15, 38, 1)' size={22} lineHeight="28px" weight={700} style={{ fontFamily: 'Nunito' }}>
                                    {item.name}
                                  </MyText>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </StyledCarousel>) : (
                    <>
                    {multimedia
                    .filter(item => item.playlist_id === playlist.id)
                    .map((item) => {
                      const videoId = new URL(item.link).searchParams.get('v');
                      const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

                      return (
                        <div key={item.id} style={{ padding: isMobile ? '0' : '0 8px' }}>
                          <div onClick={() => handleVideoClick(item.link)} onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(0.97)'}
                            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'} style={{ cursor: 'pointer', transition: 'transform 0.3s ease', width: '95%' }}>
                            <div style={{
                              borderRadius: '12px',
                              background: '#fff',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                            }}>
                              <div style={{
                                width: '100%',
                                paddingTop: '55.25%',
                                position: 'relative',
                                borderRadius: '12px',
                                overflow: 'hidden',
                              }}>
                                <img
                                  src={thumbnailUrl}
                                  alt={item.name}
                                  style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover'
                                  }}
                                />
                              </div>
                              <div style={{
                                display: 'flex',
                                width: '100%',
                                marginTop: '24px',
                                justifyContent: 'flex-start',
                              }}>
                                <MyText color='rgba(19, 15, 38, 1)' size={22} lineHeight="28px" weight={700} style={{ fontFamily: 'Nunito' }}>
                                  {item.name}
                                </MyText>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    </>

                  )}

                  </div>
                </Col>
              </Row>
            </div>
          ))}
      
          {selectedVideo && (
            <Modal
              open={modalVisible}
              onCancel={handleModalClose}
              footer={null}
              width={isMobile ? '100%' : '50%'}
              bodyStyle={{ padding: isMobile ? 14 : 30 }}
              style={{ top: 70 }}
            >
              <div style={{ position: 'relative', paddingBottom: isMobile ? '100%' : '56.25%', height: 0 }}>
                <iframe
                  title="video"
                  width="100%"
                  height="100%"
                  src={`https://www.youtube.com/embed/${new URL(selectedVideo).searchParams.get('v')}`}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                ></iframe>
              </div>
            </Modal>
          )}
        </Card>
          </Col>
        </Row>
      </Col>
    </Row>
    </>
  )
}